module.exports = __webpack_public_path__ + "img/2.9d22726.jpg";